import { Link, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useOrganizationViewUrl } from '../../../../../../../../../../hooks/routing/useOrganizationViewUrl'
import { reactRoute } from '../../../../../../../../../../utils/routing/reactRoute'

interface InvoiceRecurrencePageLinkProps {
  recurringInvoiceId?: number | null
}

export const InvoiceRecurrencePageLink = ({
  recurringInvoiceId,
}: InvoiceRecurrencePageLinkProps): ReactElement | null => {
  const { t } = useTranslation()
  const { url: customerUrl } = useOrganizationViewUrl(
    reactRoute.organization.recurringInvoices.getViewRecurringInvoiceRoute(String(recurringInvoiceId)),
  )

  if (!recurringInvoiceId) {
    return null
  }

  return (
    <Text alignment="left" colorVariant="primary" variant="bodySM" weight="bold">
      <Link to={customerUrl} withAnimation>
        {t('external_invoices.view.sidebar.details_card.part_of_recurrence.link.label')}
      </Link>
    </Text>
  )
}
